import { render, staticRenderFns } from "./single-default.vue?vue&type=template&id=cea7b918&"
import script from "./single-default.vue?vue&type=script&lang=js&"
export * from "./single-default.vue?vue&type=script&lang=js&"
import style0 from "./single-default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/builds/pagsmile/front-end/pagsmile-web/components/Header.vue').default,Footer: require('/builds/pagsmile/front-end/pagsmile-web/components/Footer.vue').default})
